module.exports = "/_next/static/images/santehnka-2614e4aa9feb9796d0ce6af05a3c92ee.svg";